import { combineEpics, ofType } from "redux-observable";
import { catchError, endWith, from, map, of, startWith, switchMap, withLatestFrom } from "rxjs";
import { DeleteCaseComment, GetCaseComments, GetChangeLog, PostCaseComment } from "../../services/comments/comments.service";
import { setCaseComments, setChangeLog, setLoading } from "../../store/comments/commentSlice";

const getCaseComments = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("comments/getCaseComments"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
            };
            const caseId = payload?.caseId || '';
            return from(GetCaseComments(caseId)).pipe(
                map((response) => {
                    if (response) {
                        return setCaseComments(response);
                    } else {
                        return setCaseComments({
                            comments: [],
                            commentsCount: 0
                        });
                    }

                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

const getPostComments = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("comments/getPostComments"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload?.payload,
            };
            return from(PostCaseComment(payload)).pipe(
                switchMap((response) => {
                    if (response) {
                        return from(GetCaseComments(actionData?.payload?.caseId)).pipe(
                            map((res) => {
                                if (res) {
                                    return setCaseComments(res);
                                } else {
                                    return setCaseComments({
                                        comments: [],
                                        commentsCount: 0
                                    });
                                }
                            })
                        );
                    } else {
                        return of(setCaseComments({
                            comments: [],
                            commentsCount: 0
                        }));
                    }
                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

const getDeleteComments = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("comments/getDeleteComments"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            return from(DeleteCaseComment(actionData?.payload?.id)).pipe(
                switchMap((response) => {
                    if (response) {
                        return from(GetCaseComments(actionData?.payload?.caseId)).pipe(
                            map((res) => {
                                if (res) {
                                    return setCaseComments(res);
                                } else {
                                    return setCaseComments({
                                        comments: [],
                                        commentsCount: 0
                                    });
                                }
                            })
                        );
                    } else {
                        return of(setCaseComments({
                            comments: [],
                            commentsCount: 0
                        }));
                    }
                }),
                catchError((error) => {
                    return of(console.error(error));
                }),
                startWith(setLoading(true)),
                endWith(setLoading(false))
            );
        })
    );
};

export const getChangeLog = (action$: any, state$: any) => {
    return action$.pipe(
        ofType("comments/getChangeLog"),
        withLatestFrom(state$),
        switchMap(([actionData, state]) => {
            const payload = {
                ...actionData?.payload,
            };
            const caseId = payload?.caseId || '';
            return from(GetChangeLog(caseId)).pipe(
                switchMap((response) => {
                    if (response) {
                        return of(setChangeLog(response));
                    } else {
                        return of(setChangeLog([]));
                    }
                })
            );
        })
    );
};

export const commentsEpic = combineEpics(
    getCaseComments,
    getPostComments,
    getDeleteComments,
    getChangeLog
);